import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import TriggersListView from '../view/TriggersListView';
import * as actions from '../actions';

export class TriggersList extends React.Component {
	render() {
		const { status, errorDetail, triggers } = this.props;
		if (status === 'error') {
			return (
				<ErrorPage errorDetail={errorDetail} />
			);
		} else if (!triggers || status === 'loading') {
			return <ContentLoading />;
		}

		return (
			<TriggersListView
				triggers={triggers}
			/>
		);
	}
}

TriggersList.propTypes = {
	status: PropTypes.string,
	errorDetail: PropTypes.object,
	triggers: PropTypes.array
};

function mapStateToProps(state) {
	return {
		triggers: state.triggers.triggers,
		status: state.triggers.status,
		errorDetail: state.triggers.errorDetail
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TriggersList);
